import UIComponent from "../../common/UIComponent";
import markPoints from '../../component/markpoints'
import "./index.css";

export default class H5Progress extends UIComponent {

  constructor(elementId, interfaces, videoId, markPoints, AiHightlights) {
    super();
    this.interfaces = interfaces;
    this.elementId = elementId;
    this.markPoints = markPoints;
    this.AiHightlights = AiHightlights;

    this.videoNode = document.querySelector(`${videoId}`);
    this.init();

    this.interfaces.on(VhallPlayer.TIMEUPDATE, () => {

      // TODO: 解决IOS上 IndexSizeError: The index is not in the allowed range.  报错
      if (this.interfaces.getBuffered().length <= 0) { return; }
      const progressLoadValue = ((this.interfaces.getBuffered().end(this.interfaces.getBuffered().length - 1) / this.interfaces.getDuration()) * 100);
      this.progressLoad.style.width = progressLoadValue + "%";

      // seek状态时 不设置进度条的值
      if (this.isSeeking) { return; }

      const progressPlayValue = ((this.interfaces.getCurrentTime() / this.interfaces.getDuration()) * 100);
      this.progressPlay.style.width = progressPlayValue + "%";
      this.scrubberBox.style.left = progressPlayValue + "%";
      // this.scrubber.style.left = progressPlayValue + "%";
    });
  }

  init() {

    this.progressContainer = document.createElement("div");
    this.progressContainer.setAttribute("class", "vhallPlayerh5-progress-container");
    this.progressContainer.ontouchstart = this.handleMouseDown.bind(this)

    this.progressLoad = document.createElement("div");
    this.progressLoad.setAttribute("class", "vhallPlayerh5-progress-load");

    this.progressPlay = document.createElement("div");
    this.progressPlay.setAttribute("class", "vhallPlayerh5-progress-play");

    this.scrubberBox = document.createElement('div');
    this.scrubberBox.setAttribute("class", "vhallPlayerh5-progress-scrubberBox");

    this.scrubber = document.createElement("div");
    this.scrubber.setAttribute("class", "vhallPlayerh5-progress-scrubber");
    // this.scrubber.innerHTML = `<i></i>`;

    this.progressContainer.appendChild(this.progressLoad);
    this.progressContainer.appendChild(this.progressPlay);
    this.scrubberBox.appendChild(this.scrubber);
    this.progressContainer.appendChild(this.scrubberBox);

    /**
     * 将 构造DOM 插入到指定 DOM 中，不用选择器
     * */
    this.insertElement(this.elementId, this.progressContainer);

    new markPoints('.vhallPlayerh5-progress-container', this.interfaces, this.markPoints, this.AiHightlights)
  }


  handleMouseDown(event) {
    this.isSeeking = true;  // 按下鼠标时 则为正在seek
    let currentTime = null;   // 当前播放时间值
    const downClientX = event.targetTouches[0].clientX;

    const mouseX = downClientX - (this.progressContainer.offsetLeft + this.videoNode.offsetLeft);
    currentTime = mouseX / this.progressContainer.offsetWidth * this.interfaces.getDuration();
    this.scrubberBox.style.left = mouseX / this.progressContainer.offsetWidth * 100 + '%';
    // this.scrubber.style.left = mouseX / this.progressContainer.offsetWidth * 100 + '%';
    this.progressPlay.style.width = mouseX / this.progressContainer.offsetWidth * 100 + '%';
    this.progressLoad.style.width = 0 + "%";


    const progressPlayWidth = this.progressPlay.offsetWidth;

    document.ontouchmove = event => {

      const moveL = event.targetTouches[0].clientX - downClientX;
      const newL = progressPlayWidth + moveL;

      if (newL / this.progressContainer.offsetWidth < 0 || newL / this.progressContainer.offsetWidth > 1) { return; }

      currentTime = newL / this.progressContainer.offsetWidth * this.interfaces.getDuration();
      this.scrubberBox.style.left = newL / this.progressContainer.offsetWidth * 100 + '%';
      // this.scrubber.style.left = newL / this.progressContainer.offsetWidth * 100 + '%';
      this.progressPlay.style.width = newL / this.progressContainer.offsetWidth * 100 + '%';

    }

    document.ontouchend = (e) => {

      // 鼠标抬起设置当前播放时间
      this.interfaces.setCurrentTime(currentTime);
      // 重置预加载条
      this.progressLoad.style.width = 0 + "%";

      // 关闭seek状态
      this.isSeeking = false;

      // 移除鼠标移动事件
      document.ontouchmove = null;

      // 移除鼠标抬起事件
      document.ontouchend = null;
    }
  }

}